// Barrel. Everything outside services/camera/ imports from here, never from
// inside the folder — mirrors services/realtime-connection-store.js, so the
// internals can move without a repo-wide rename.
//
// Plain functions wrap useCameraManagerStore.getState().<action>() for click
// handlers and other non-React call sites; the hook itself is exported for
// anything that wants to render off camera state reactively (permission
// state, camera list, current settings).
import { useCameraManagerStore } from './camera/store';
import { CAMERA_ERROR_CODE } from './camera/errors';
import { logCamera } from './camera/debug';
import { DEFAULT_CAPTURE_WIDTH } from './camera/constants';

export { useCameraManagerStore, CAMERA_ERROR_CODE, logCamera, DEFAULT_CAPTURE_WIDTH };

export function requestCameraPermission() {
  return useCameraManagerStore.getState().requestPermission();
}

export function initializeCamera(options) {
  return useCameraManagerStore.getState().initializeCamera(options);
}

export function enumerateCameras() {
  return useCameraManagerStore.getState().enumerateCameras();
}

export function switchCamera(target) {
  return useCameraManagerStore.getState().switchCamera(target);
}

export function stopCamera(reason) {
  return useCameraManagerStore.getState().stopCamera(reason);
}

export function restoreCameraPreference(options) {
  return useCameraManagerStore.getState().restoreCameraPreference(options);
}

/**
 * The live MediaStream, if any — for a caller that needs to assign it to a
 * `<video>` element's `srcObject` directly rather than subscribing to the
 * store (the stream itself is deliberately not reactive state, see
 * services/camera/store.js).
 */
export function getActiveCameraStream() {
  return useCameraManagerStore.getState().runtime.stream;
}
